export default "__VITE_ASSET__dBNGPtVs__"